import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const slides = [{
  id: 1,
  image: 'https://cdn.magicpatterns.com/uploads/brVNatcfAghfBMbNNV5R3L/5bec92ee-4f90-4b6f-a2c3-24cba50de417.jpg'
}, {
  id: 2,
  image: 'https://cdn.magicpatterns.com/uploads/iGP65naKn2ChuiFoGF8o99/7dbcf6a3-ea29-4e7a-a764-b75d28fd919f.jpg'
}, {
  id: 3,
  image: 'https://cdn.magicpatterns.com/uploads/f69EJCqg8cTEfVBTp9PywJ/c00b534d-67c4-49db-8360-a9219fb2dc9b.jpg'
}, {
  id: 4,
  image: 'https://cdn.magicpatterns.com/uploads/w321oBfpaKEMXxiSNYC6Wq/e5141692-0487-4aa0-a915-5c570ab4c033_2.jpg'
}];
export function WeddingCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  useEffect(() => {
    const timer = setInterval(() => {
      setDirection(1);
      setCurrentIndex(prev => (prev + 1) % slides.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? '5%' : '-5%',
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? '5%' : '-5%',
      opacity: 0
    })
  };
  return <div className="relative w-full overflow-hidden" data-id="element-56">
      <div className="relative w-full h-[55vh] md:h-[75vh] rounded border-[5px] border-white/90 shadow-[0_2px_20px_rgba(0,0,0,0.06)] overflow-hidden" data-id="element-57">
        <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-58">
          <motion.div key={currentIndex} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
          x: {
            type: 'spring',
            stiffness: 200,
            damping: 40,
            mass: 1
          },
          opacity: {
            duration: 1.5,
            ease: [0.25, 0.1, 0.25, 1]
          }
        }} className="absolute inset-0 w-full h-full" data-id="element-59">
            <motion.img src={slides[currentIndex].image} alt={`Boda en Hacienda El Rosario ${currentIndex + 1}`} initial={{
            scale: 1.05
          }} animate={{
            scale: 1
          }} transition={{
            duration: 10,
            ease: 'easeOut'
          }} className="w-full h-full object-cover pointer-events-none" data-id="element-60" />
          </motion.div>
        </AnimatePresence>

        {/* Indicators */}
        <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 flex space-x-4 z-10" data-id="element-61">
          {slides.map((_, idx) => <button key={idx} onClick={() => {
          setDirection(idx > currentIndex ? 1 : -1);
          setCurrentIndex(idx);
        }} className={`h-[1px] transition-all duration-700 ease-in-out ${idx === currentIndex ? 'w-12 bg-white' : 'w-6 bg-white/30 hover:bg-white/60'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-62" />)}
        </div>
      </div>
    </div>;
}